module.exports = __webpack_public_path__ + "static/spark-express-0e3c221677c1a5d194dce8778eebab8a.svg";